import { render, staticRenderFns } from "./add.vue?vue&type=template&id=6857ff61&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6857ff61')) {
      api.createRecord('6857ff61', component.options)
    } else {
      api.reload('6857ff61', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=6857ff61&", function () {
      api.rerender('6857ff61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/communityPartyBuilding/activityApply/outPersion/add.vue"
export default component.exports